<template>
  <project-template title="确认方案成本" nextBtnText="下一步：纳排标准" @lastClick="lastClick" @nextClick="nextClick">
    <template v-slot:leftContent>
      <div class="project-template-card">
        <div class="card-title" style="display:block;text-align: center;">
          {{ project.name || '-' }}
        </div>
        <br />
        <a-row :gutter="10" class="row1">
          <a-col :span="12" class="label">
            研究科室
          </a-col>
          <a-col :span="12" class="label">
            研究病种
          </a-col>
        </a-row>
        <a-row :gutter="10" class="row1">
          <a-col :span="12" class="one-row">
            <a-tag v-for="dept in deptList" :key="dept.code">{{ dept.name }}</a-tag>
          </a-col>
          <a-col :span="12" class="one-row">
            <a-tag v-for="disease in diseaseList" :key="disease.code">{{ disease.name }}</a-tag>
          </a-col>
        </a-row>
        <br />
        <!-- 11 -->
        <a-row :gutter="10" class="row1">
          <a-col :span="12" class="label">
            随访周期
          </a-col>
          <a-col :span="12" class="label">
            表单数量
          </a-col>
        </a-row>

        <a-row :gutter="10" class="row1">
          <a-col :span="12" class="label2">
            {{ periodItemList.length || '0' }}期
          </a-col>
          <a-col :span="12" class="label2">
            {{ formList.length || '0' }}张
          </a-col>
        </a-row>
        <!-- 22 -->
        <div class="info-card-item">
          <div class="info-item" v-for="(costItem, index) in costItemList" :key="index">
            <div class="label">
              {{ costItem.costName }}
            </div>
            <div class="label-value">
              <strong>{{ costItem.formNum || '-' }}</strong>
              <span>期</span>
            </div>
          </div>
        </div>
      </div>
      <div class="project-template-card">
        <div class="card-title">
          <strong>基本信息</strong>
          <span>填写后会自动计算人力、时间成本投入</span>
        </div>
        <hr class="line" />
        <a-row :gutter="5" class="row1" style="margin-top: 10px">
          <a-col :span="11" class="col-item">
            <span style="color:red;margin-right: 3px;">*</span>
            <span>受试者人数</span>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11" class="col-item">
            <span style="color:red;margin-right: 3px;">*</span>
            <span>每日收入人数</span>
          </a-col>
        </a-row>
        <a-row :gutter="5" class="row1">
          <a-col :span="11">
            <a-input ref="patientCount" v-model="baseInfo.patientCount" @blur="patientCountChange" placeholder="请输入"
              :min="0" :precision="0" class="input-num" />
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-input ref="patientDayCount" v-model="baseInfo.patientDayCount" @blur="patientCountChange"
              placeholder="请输入" :min="0" :precision="0" class="input-num" />
          </a-col>
        </a-row>
      </div>
      <div class="project-template-card" @click="handleItemClick(viewKeyMap.timeCost, '时间投入成本')">
        <div class="card-title2">
          <strong>时间成本</strong>
          <div class="right-item2">
            <label class="number">
              <span class="sp1">{{ projectCostInfo.timeCost || '0' }}</span>
              <span class="sp2">天</span>
            </label>
            <a-icon type="right" class="right-arrow" />
          </div>
        </div>
      </div>
      <div class="project-template-card">
        <!-- <div class="card-title2">
          <strong>成本总投入</strong>
          <div class="right-item2">
            <label class="number">
              <span>￥</span>
              <span class="sp1">{{ projectCostInfo.totalCost || '0' }}</span>
            </label>
          </div>
        </div>
        <div ref="charts" style="height: 160px;margin-top: 10px"></div>
        <hr class="line2" /> -->
        <div class="card-title2 pb18" @click="handleItemClick(viewKeyMap.personCost, '人力成本投入')">
          <strong>人力成本</strong>
          <div class="right-item">
            <label class="number">
              <span>￥</span>
              <span class="sp1">{{ projectCostInfo.personCost || 0 }}</span>
              <span class="sp2">元</span>
            </label>
            <a-icon type="right" style="color: white;margin-left: 20px;" />
          </div>
        </div>
        <hr class="line2" />
        <!-- <div class="card-title2  pt18 pb18" @click="viewKey = viewKeyMap.consumableCost"> -->
        <div class="card-title2  pt18 pb18" @click="handleItemClick(viewKeyMap.consumableCost, '耗材成本投入')">
          <strong>耗材成本</strong>
          <div class="right-item">
            <label class="number">
              <span>￥</span>
              <span class="sp1">{{ projectCostInfo.materialCost || 0 }}</span>
              <span class="sp2">元</span>
            </label>
            <a-icon type="right" style="color: white;margin-left: 20px;" />
          </div>
        </div>
        <hr class="line2" />
        <div class="card-title2 pt18">
          <strong>总成本</strong>
          <div class="right-item2">
            <label class="number">
              <span>￥</span>
              <span class="sp1">{{ projectCostInfo.totalCost || '0' }}</span>
              <span class="sp2">元</span>
            </label>
          </div>
        </div>
        <div ref="charts" style="height: 160px;margin-top: 10px"></div>

      </div>
    </template>
    <template v-slot:rightContent>

      <div v-if="viewKey == viewKeyMap.timeCost" class="box box1">

        <div class="project-template-card">
          <div class="head">
            <strong>时间成本</strong>
            <div class="day">
              <strong>{{ projectCostInfo.timeCost || 0 }}</strong>
              <span>天</span>
            </div>
          </div>
          <div class="card-block">
            <a-row :gutter="20" class="row2">
              <a-col :span="12">开始时间</a-col>
              <a-col :span="12">结束时间</a-col>
            </a-row>
            <a-row :gutter="20">
              <a-col :span="12">
                <a-date-picker :inputReadOnly="true" value-format='YYYY-MM-DD' style="width: 100%" placeholder="请选择开始日期"
                  v-model="timeCostModel.startDate" />
              </a-col>
              <a-col :span="12">
                <a-date-picker :inputReadOnly="true" value-format='YYYY-MM-DD' style="width: 100%" placeholder="请选择开始日期"
                  v-model="timeCostModel.endDate" />
              </a-col>
            </a-row>
          </div>
          <!-- <div class="card-switch">
            <a-row :gutter="20" class="row2">
              <a-col :span="12">节假日</a-col>
              <a-col :span="12" style="text-align: right;"><a-switch v-model='timeCostModel.holidayBl' @change="change"/></a-col>
            </a-row>
          </div> -->
        </div>
        <a-button class="btn-common" type="primary" @click="handleSubmitTimeCost">
          保存
        </a-button>
      </div>

      <div v-if="viewKey == viewKeyMap.personCost" class="box box2">

        <div class="project-template-card">

          <div class="head">
            <strong>人力成本</strong>
            <div class="day">
              <strong>￥{{ projectCostInfo.personCost || 0 }}</strong>
            </div>
          </div>
          <div class="card-block">
            <a-row :gutter="20" class="row2">
              <a-col :span="12">平均所需调查员（人数）</a-col>
              <a-col :span="12">所需项目管理成员（人数）例如：PI、项目管理员等</a-col>
            </a-row>
            <a-row :gutter="20" class="row1">
              <a-col :span="12">
                <a-input v-model="personCostModel.dataUserCount" :min="0" :precision="0" style="width: 90%" />
              </a-col>
              <a-col :span="12">
                <a-input v-model="personCostModel.otherUserCount" :min="0" :precision="0" style="width: 90%" />
              </a-col>
            </a-row>
          </div>
          <div class="card-block">
            <a-row :gutter="20" class="row2">
              <a-col :span="12">人力成本单价：人/月/元</a-col>
            </a-row>
            <a-row :gutter="20" class="row1">
              <a-col :span="12">
                <a-input v-model="personCostModel.personCostDay" :min="0" :precision="0" style="width: 90%" />
              </a-col>
            </a-row>
          </div>
        </div>
        <!-- <div class="project-template-card">
          <div style="color: white;">修改随访成本</div>
          <div style="margin-top: 10px;">
            <a-button style="margin-right: 20px" @click="handlePeriodEdit()">
              时长（随访周期、随访内容）修改
            </a-button>
            <a-button @click="handlePatientCountEdit()">
              受试者人数修改
            </a-button>
        </div>
        </div> -->

        <a-button class="btn-common" type="primary" @click="handleSubmitPersonCost()">
          保存
        </a-button>

        <div ref="scatterChart" style="width: 1000px; height:400px;"></div>

      </div>

      <div v-if="viewKeyMap.consumableCost == viewKey" class="box box3">
        <div class="project-template-card">
          <div class="head">
            <strong>耗材成本</strong>
            <div class="day">
              <strong>￥{{ projectCostInfo.materialCost || 0 }}元</strong>
            </div>
          </div>
          <div class="card-block">
            <a-row :gutter="20" style="margin-top: 15px">
              <template v-if="materialData.length > 0">
                <a-col :span="12" v-for="material in materialData" :key="material.id">
                  <div class="project-template-card" style="margin-bottom: 0;position: relative;">
                    <div class="right-btn">
                      <a-button icon="delete" type="link" size="small" class="btn-item"
                        @click="materialHandleDelete(material.id)"></a-button>
                      <a-button icon="edit" type="link" size="small" class="btn-item"
                        @click="materialHandleEdit(material)"></a-button>
                    </div>
                    <div class="item-title">
                      {{ material.name }}
                    </div>
                    <a-row>
                      <a-col :span="12">
                        <span class="key">耗材</span>
                        <span class="value">{{ material.material }}</span>
                      </a-col>
                      <a-col :span="12">
                        <span class="key">推荐</span>
                        <span class="value">{{ material.recommendation }}</span>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span="12">
                        <span class="key">数量</span>
                        <span class="value">{{ material.num }}</span>
                      </a-col>
                      <a-col :span="12">
                        <span class="key">成本</span>
                        <span class="value">{{ material.price }}元</span>
                      </a-col>
                    </a-row>
                  </div>
                </a-col>
              </template>
              <a-col :span="12" v-else>
                <div class="project-template-card">
                  <div class="card-title ">
                    暂无成本内容，请添加。
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
        <a-button class="add" icon="plus" @click="materialHandleAdd">添加</a-button>
        <a-modal class="ant-modal-custom" :width="'600px'" :visible="materialObj.visible"
          :confirmLoading="materialObj.confirmLoading" switchFullscreen @cancel="handleMaterialCancel" cancelText="关闭">
          <div class="modal-title">
            耗材添加
          </div>

          <template slot="footer">
            <gradient-btn @click="handleMaterialOk">确认</gradient-btn>
          </template>

          <a-spin :spinning="materialObj.confirmLoading">
            <a-tabs class="tabs" v-model="materialObj.activeKey">
              <a-tab-pane key="1" tab="可选耗材" v-if="!materialObj.model.id">
                <a-table ref="table" rowKey="id" size="middle"
                  :row-selection="{ selectedRowKeys: materialObj.selectedRowKeys, onChange: onSelectMaterialChange }"
                  :columns="materialObj.columns" :dataSource="materialSourceData" :pagination="false">
                </a-table>
              </a-tab-pane>
              <a-tab-pane key="2" :tab="materialObj.model.id ? '编辑' : '自定义耗材'">
                <a-form-model layout="horizontal" :model="materialObj.model" ref="ruleForm" :rules="materialObj.rules">
                  <div class="item">
                    <a-form-model-item prop="name" label="项目名称">
                      <a-input placeholder="请输入" v-model="materialObj.model.name" />
                    </a-form-model-item>
                  </div>
                  <div class="item">
                    <a-form-model-item prop="material" label="耗材">
                      <a-input placeholder="请输入" v-model="materialObj.model.material" />
                    </a-form-model-item>
                  </div>
                  <div class="item">
                    <a-form-model-item prop="recommendation" label="推荐">
                      <a-input placeholder="请输入" v-model="materialObj.model.recommendation" />
                    </a-form-model-item>
                  </div>
                  <div class="item">
                    <a-form-model-item prop="price" label="单价">
                      <a-input-number placeholder="请输入" v-model="materialObj.model.price" :min="1" :precision="0"
                        style="width: 100%" />
                    </a-form-model-item>
                  </div>
                  <div class="item">
                    <a-form-model-item prop="num" label="数量">
                      <a-input-number placeholder="请输入" v-model="materialObj.model.num" :min="1" :precision="0"
                        style="width: 100%" />
                    </a-form-model-item>
                  </div>
                </a-form-model>
              </a-tab-pane>
            </a-tabs>
          </a-spin>
        </a-modal>
      </div>
    </template>
  </project-template>
</template>

<script>
import * as echarts from 'echarts'
import { deleteAction, getAction, postAction } from '@api/manage'
import baseRules from '@/constants/baseRules'
import IconBack from '@comp/Icon/IconBack'
import ProjectTemplate from '@comp/pad/ProjectTemplate'
import GradientBtn from '@comp/pad/GradientBtn'
import dayjs from 'dayjs'

export default {
  name: 'ProjectTemplate4',
  components: { IconBack, GradientBtn, ProjectTemplate },
  data() {
    return {
      rawData: [],
      myChart: null,
      myChart1: null,
      viewEcharts: false,
      project: {},
      baseInfo: {
        // patientCount: sessionStorage.getItem('result')||0,
        patientCount: 0,
        patientDayCount: 0
      },
      queryParam: {},
      viewKey: '',
      viewKeyMap: {
        info: 'info', //基本信息
        timeCost: 'timeCost',// 时间成本
        personCost: 'personCost',//人力成本
        consumableCost: 'consumableCost', //耗材成本
        otherCost: 'otherCost'//其他成本、可选资源
      },
      periodItemList: [],
      personCostModel: {},
      timeCostModel: {},
      projectCostInfo: {},
      materialData: [],
      materialSourceData: [],

      confirmLoading: false,
      materialObj: {
        model: {},
        rules: {
          name: [baseRules.required],
          material: [baseRules.required],
          recommendation: [baseRules.required],
          price: [baseRules.required],
          num: [baseRules.required]
        },
        visible: false,
        confirmLoading: false,
        activeKey: '1',
        selectedRowKeys: [],
        selectedRows: [],
        columns: [
          {
            title: '项目名称',
            ellipsis: true,
            dataIndex: 'name'
          },
          {
            title: '耗材',
            ellipsis: true,
            dataIndex: 'material'
          },
          {
            title: '推荐',
            ellipsis: true,
            dataIndex: 'recommendation'
          },
          {
            title: '单价',
            ellipsis: true,
            dataIndex: 'price'
          }
        ]
      },
      holidays: [
        '2024-01-01', // 元旦
        '2024-02-10', // 春节
        '2024-02-11', // 春节
        '2024-02-12', // 春节
        '2024-04-04', // 清明节
        '2024-05-01', // 劳动节
        '2024-06-10', // 端午节
        '2024-09-17', // 中秋节
        '2024-10-01', // 国庆节
        '2024-10-02', // 国庆节
        '2024-10-03' // 国庆节
      ]
    }
  },
  computed: {
    deptList() {
      if (this.project.deptJson) {
        return JSON.parse(this.project.deptJson)
      }
      return []
    },
    diseaseList() {
      if (this.project.diseaseJson) {
        return JSON.parse(this.project.diseaseJson)
      }
      return []
    },
    formList() {
      const formCodeList = []
      const result = []
      if (this.project.moduleJson) {
        const moduleObject = JSON.parse(this.project.moduleJson)
        for (let key in moduleObject) {
          const moduleList = moduleObject[key]
          moduleList.forEach(module => {
            if (module.checkedFormList) {
              module.checkedFormList.forEach(form => {
                if (formCodeList.indexOf(form.code) < 0) {
                  formCodeList.push(form.code)
                  result.push(form)
                }
              })
            }
          })
        }
      }
      return result
    },
    costItemList() {
      if (this.project.costJson) {
        return JSON.parse(this.project.costJson)
      } else {
        return []
      }
    }
  },
  mounted() {
    //this.rawData = this.generateSalesData('2015-01-01', '2016-03-31')
    //this.rawData = this.calculateMonthlyAverages(this.rawData)
    this.loadProjectData()
    this.loadMaterialDataAll()
    this.loadPeriodItemData()
    this.initChart()
  },
  methods: {
    generateSalesData(startDate, endDate) {
      const salesData = []
      const start = new Date(startDate)
      const end = new Date(endDate)

      // 创建一个日期迭代器
      let currentDate = new Date(start)

      while (currentDate <= end) {
        // 假设销售量是随机数，可以根据实际情况调整
        const salesVolume = Math.floor(Math.random() * 100) // 销售量在0到99之间
        const temp = [new Date(currentDate).toISOString().split('T')[0], salesVolume]

        // 将销售数据添加到数组中
        salesData.push(temp)

        // 迭代到下一天
        currentDate.setDate(currentDate.getDate() + 1)
      }

      return salesData
    },
    calculateMonthlyAverages(salesData) {
      const monthlyTotals = {}
      const monthlyCounts = {}

      // 遍历每一天的销售数据
      salesData.forEach(day => {
        const date = new Date(day[0])
        const yearMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}` // 获取年份和月份

        if (!monthlyTotals[yearMonth]) {
          monthlyTotals[yearMonth] = 0
          monthlyCounts[yearMonth] = 0
        }

        // 累加销售量并计数
        monthlyTotals[yearMonth] += day[1]
        monthlyCounts[yearMonth] += 1
      })

      // 计算平均值
      const monthlyAverages = Object.keys(monthlyTotals).map(yearMonth => ({
        month: yearMonth,
        average: Math.ceil(monthlyTotals[yearMonth] / monthlyCounts[yearMonth])
      }))

      const arr = []

      monthlyAverages.forEach(data => {
        const temp = [data.month, data.average]
        arr.push(temp)
      })
      return arr
    },
    change(checked) {
      const { startDate, endDate } = this.timeCostModel
      if (dayjs(startDate).isAfter(dayjs(endDate))) {
        return this.$message.warn('开始时间不能大于结束时间')
      }
      if (checked) {
        const num = this.getHolidayCountInRange(startDate, endDate)
        this.timeCostModel.endDate = dayjs(this.addDays(endDate, num)).format('YYYY-MM-DD')
      }
    },
    //dateString: string
    parseDate(dateString) {
      return new Date(dateString)
    },
    //date: Date, days: number
    addDays(date, days) {
      const result = new Date(date)
      result.setDate(result.getDate() + days)
      return result
    },
    //startDate: string, endDate: string
    getHolidayCountInRange(startDate, endDate) {
      const start = this.parseDate(startDate)
      const end = this.parseDate(endDate)

      let holidayCount = 0
      let currentDate = start

      while (currentDate <= end) {
        const dateString = currentDate.toISOString().split('T')[0]
        if (this.holidays.includes(dateString)) {
          holidayCount++
        }
        currentDate = this.addDays(currentDate, 1)
      }

      return holidayCount
    },
    handleItemClick(str, title) {
      this.viewKey = str
      if (str === 'personCost') {
        this.$nextTick(() => {
          this.initCharts()
        })
      }
    },
    handlePeriodEdit() {
      this.$emit('goBack', 2)
    },
    handlePatientCountEdit() {
      this.$nextTick(() => {
        this.$refs.patientDayCount.focus()
      })
    },
    onSelectMaterialChange(selectedRowKeys, selectionRows) {
      this.materialObj.selectedRowKeys = selectedRowKeys
      this.materialObj.selectedRows = selectionRows
    },
    materialHandleAdd() {
      this.materialHandleEdit({
        projectId: this.project.id
      })
    },
    materialHandleEdit(record) {
      this.materialObj.activeKey = '1'
      this.materialObj.selectedRowKeys = []
      this.materialObj.selectedRows = []
      this.materialObj.model = record
      this.materialObj.visible = true
    },
    materialHandleDelete(id) {
      this.$confirm({
        title: '彻底删除',
        content: (<div>
          <p>您确定要彻底删除这条数据吗？</p>
        </div>),
        centered: false,
        onOk: () => {
          deleteAction('/projectconfigview/material/delete', { id: id }).then(res => {
            if (res.success) {
              this.loadMaterialDataAll()
              this.loadProjectData()
            }
          })
        }
      })

    },
    handleMaterialCancel() {
      this.loadProjectData()
      this.materialObj.visible = false
    },
    handleMaterialOk() {
      if (this.materialObj.activeKey == '1') {
        if (this.materialObj.selectedRowKeys.length == 0) {
          return this.$message.warning('请选择至少一条数据')
        }
        const params = {
          projectId: this.project.id,
          ids: this.materialObj.selectedRowKeys.join(',')
        }
        // 走选项添加
        this.confirmLoading = true
        postAction('/projectconfigview/material/saveByIds', params).then(res => {
          if (res.success) {
            this.handleMaterialCancel()
            this.loadMaterialDataAll()
          }
        }).finally(() => {
          this.confirmLoading = false
        })
      } else {
        // 走单个编辑
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            const params = Object.assign({ projectId: this.project.id }, this.materialObj.model)
            this.materialObj.confirmLoading = true
            postAction('/projectconfigview/material/save', params).then(res => {
              if (res.success) {
                this.loadMaterialDataAll()
                this.handleMaterialCancel()
              }
            }).finally(() => {
              this.materialObj.confirmLoading = false
            })
          }
        })
      }
    },
    patientCountChange() {
      const res = this.validate()
      if (res === undefined) {
        const params = Object.assign({ projectId: this.project.id }, this.baseInfo)
        postAction('/projectconfigview/configProject/savePatientCount', params).then(res => {
          if (res.success) {
            res.result.forEach(item => {
              let dayData = []
              const entries = Object.entries(item);
              entries.forEach(([key, value]) => {
                dayData.push(key.substring(0, 10));
                dayData.push(value);
              });
              this.rawData.push(dayData)
            })

            this.loadProjectData()
            this.$nextTick(() => {
              this.initCharts()
            })
          }
        })
      }
    },
    handleSubmitPersonCost() {
      this.personCostModel.otherUserCount = this.personCostModel.otherUserCount || 0
      if (this.personCostModel.personCostDay && (this.personCostModel.dataUserCount)) {
        const params = Object.assign({ projectId: this.project.id }, this.personCostModel)
        postAction('/projectconfigview/configProject/savePersonCost', params).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadProjectData()
          } else {
            this.$message.warn(res.message)
          }
        })
      } else {
        return this.$message.warning('受试者人数必须大于0')
      }
    },
    handleSubmitTimeCost() {
      const { startDate, endDate, holiday, holidayBl } = this.timeCostModel
      if (dayjs(startDate).isAfter(dayjs(endDate))) {
        return this.$message.warn('开始时间不能大于结束时间')
      }

      this.timeCostModel.holiday = holidayBl ? '1' : '0'
      if (startDate && endDate) {
        const params = Object.assign(
          {
            projectId: this.project.id
          },
          this.timeCostModel)
        if (this.validate() === undefined) {
          postAction('/projectconfigview/configProject/saveTimeCost', params).then(res => {
            if (res.success) {
              this.$message.success(res.message)
              this.loadProjectData()
            } else {
              return this.$message.warn(res.message)
            }
          })
        }
      } else {
        return this.$message.warning('请填写完整时间')
      }
    },

    initChart() {
      const chartDom = this.$refs.charts
      this.myChart = echarts.init(chartDom)
    },

    initCharts() {
      const scatterChart = echarts.init(this.$refs.scatterChart)
      this.rawData = this.calculateMonthlyAverages(this.rawData)
      //const data = this.processData(this.rawData)
      console.log( this.rawData)
      const option = {
        title: {
          text: '项目周期所需调查员数量分布图'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return ` ${params[0].value[0] + '：' + params[0].value[1] + '人'}`
          }
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          splitLine: { show: true }
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: { show: true }
        },
        series: [{
          name: '销量',
          type: 'line',
          data: this.rawData
        }]
      }

      scatterChart.setOption(option)

    },
    processData(data) {
      return data.filter(item => {
        const date = new Date(item[0])
        return date >= new Date('2015-05-01') && date <= new Date('2016-3-30')
      }).map(item => {
        const date = new Date(item[0])
        return [date, item[1]]
      })
    },
    setOption() {
      const personCost = this.projectCostInfo.personCost || 0
      const materialCost = this.projectCostInfo.materialCost || 0
      let personCostRate = 0
      let materialCostRate = 0
      if (personCost || materialCost) {
        personCostRate = (personCost / (personCost + materialCost) * 100).toFixed(2)
        materialCostRate = (materialCost / (personCost + materialCost) * 100).toFixed(2)
      }
      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '4%',
          left: 'right',
          orient: 'vertical',
          textStyle: {
            color: 'white' // 设置图例字体颜色
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '80%'],
            center: ['25%', '45%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: [
              { value: personCost, name: `人力成本${personCostRate}%` },
              { value: materialCost, name: `耗材成本${materialCostRate}%` }
            ]
          }
        ]
      }
      this.myChart.setOption(option)
    },


    loadProjectData() {
      const id = this.$route.query.id
      getAction('/projectconfigview/configProject/queryById', { id: id }).then(res => {
        if (res.success) {
          this.project = res.result
          this.projectCostInfo = this.project.costInfo || {}
          this.baseInfo = {
            patientCount: this.project.costInfo.patientCount || sessionStorage.getItem('result') || 0,
            patientDayCount: this.project.costInfo.patientDayCount || 0
          }
          this.personCostModel = {
            dataUserCount: this.project.costInfo.dataUserCount || 0,
            otherUserCount: this.project.costInfo.otherUserCount || 0,
            personCostDay: this.project.costInfo.personCostDay || 0
          }
          this.timeCostModel = {
            startDate: this.project.costInfo.startDate || null,
            endDate: this.project.costInfo.endDate || null,
            holiday: this.project.costInfo.holiday,
            holidayBl: this.project.costInfo.holiday == '1'
          }
          this.setOption()
        }
      })
    },
    loadPeriodItemData() {
      const id = this.$route.query.id
      getAction('/projectconfigview/periodItem/listAll', { projectId: id }).then(res => {
        if (res.success) {
          this.periodItemList = res.result
        }
      })
    },
    loadMaterialData() {
      const id = this.$route.query.id
      getAction('/projectconfigview/material/list', { projectId: id }).then(res => {
        if (res.success) {
          this.materialData = res.result
          this.loadMaterialSourceData()
        }
      })
    },
    loadMaterialDataAll() {
      this.loadMaterialData()
    },
    loadMaterialSourceData() {
      const id = this.$route.query.id
      const codes = []
      this.materialData.forEach(material => {
        if (material.code) {
          codes.push(material.code)
        }
      })
      getAction('/projectconfigview/material/sourceList', { projectId: id, codes: codes.join(',') }).then(res => {
        if (res.success) {
          this.materialSourceData = res.result
        }
      })
    },

    validate() {
      //校验
      const { patientCount, patientDayCount } = this.baseInfo
      if (typeof patientCount === 'string') {
        if (patientCount.trim().length === 0) return this.$message.warning('请输入受试者人数')
        else if (patientCount.trim() === '0') return this.$message.warning('受试者人数必须大于0')
        else if (isNaN(Number(patientCount))) return this.$message.warning('受试者人数必须是数字')
      } else {
        if (patientCount <= 0) return this.$message.warning('受试者人数必须大于0')
      }

      if (typeof patientDayCount === 'string') {
        if (patientDayCount.trim().length === 0) return this.$message.warning('请输入每日收入人数')
        else if (patientDayCount.trim() === '0') return this.$message.warning('每日收入人数必须大于0')
        else if (isNaN(Number(patientDayCount))) return this.$message.warning('每日收入人数必须是数字')
        else if (Number(patientDayCount) > Number(patientCount)) return this.$message.warning('每日收入人数必须小于受试者人数')
      } else {
        if (patientDayCount <= 0) return this.$message.warning('每日收入人数必须大于0')
      }
    },
    nextClick() {
      const res = this.validate()
      if (res === undefined) this.$emit('next')
    },
    lastClick() {
      this.$emit('last')
    }
  }
}
</script>

<style scoped lang="less">
.project-template {
  .rows {
    margin-top: 10px;
  }

  .project-template-card {
    border: 1px solid rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 0.07);
    border-radius: 12px;
    padding: 15px;
    margin-bottom: 10px;

    .card-title {
      font-weight: 600;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 21px;
      display: flex;
      align-items: center;

      span {
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.4);
        line-height: 14px;
        margin-left: 3px;
      }
    }

    .right-btn {
      position: absolute;
      right: 0;
      top: 5px;

      .btn-item {
        color: white;
        margin-right: 10px;
      }
    }

    .info-card {
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      display: flex;
      justify-content: space-between;

      .info-item {
        display: inline-table;
        width: 70px;
      }
    }

    .right-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .row1 {
    padding: 5px 0;
  }

  .label {
    font-weight: 400;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 14px;
  }

  .label2 {
    font-weight: 400;
    font-size: 14px;
    color: white;
    line-height: 14px;
  }

  .one-row {
    span {
      padding-top: 3px;
      padding-bottom: 3px;
      font-size: 14px;
      color: white;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 8px 8px 8px 8px;
      border: 0;
    }
  }

  .label-value {
    color: white;

    strong {
      font-size: 16px;
      font-weight: bold;
    }

    span {
      font-size: 14px;
      font-weight: 600;
    }

  }

  .col-item {
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 16px;
  }

  .input-num {
    font-weight: bold;
    font-size: 18px;
    color: #FFFFFF;
    height: 54px;
    border-radius: 12px;
    border: 0;
    background: rgba(255, 255, 255, 0.15);
  }

  .line {
    height: 1px;
    border: 0;
    margin: 15px 0 0;
    background-color: rgba(255, 255, 255, 0.15)
  }

  .line2 {
    height: 1px;
    border: 0;
    margin: 0;
    background-color: rgba(255, 255, 255, 0.15)
  }

  .card-title2 {
    display: flex;
    justify-content: space-between;

    strong {
      font-weight: 600;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 21px;
      display: flex;
      align-items: center;
    }

    .right-item2 {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .number {
      color: #e74c3c;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .sp1 {
      font-weight: bold;
      font-size: 18px;
      color: #FE553E;
    }

    .sp2 {
      font-weight: 400;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 14px;
      margin-left: 5px;
    }

    .right-arrow {
      color: white;
      margin-left: 20px;
    }
  }

  .pt18 {
    padding-top: 18px;
  }

  .pb18 {
    padding-bottom: 18px;
  }
}

.box {
  height: 100%;
  position: relative;

  .btn-common {
    display: block;
    width: 100%;
    padding: 0;
    color: white;
    background: linear-gradient(90deg, #376EFF 0%, #DE5DFE 100%);
    border: none;
    border-radius: 21px;
    margin-top: 30px;
  }
}

.box3 {
  .key {
    font-weight: 400;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.4);
    line-height: 14px;
  }

  .value {
    font-weight: 400;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    margin-left: 5px;
  }
}

.title {
  position: relative;
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  color: #FFFFFF;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);

  .back {
    position: absolute;
    left: 0;
    top: 15px;
    cursor: pointer;

  }
}

.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);

  &>strong {
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
  }

  .day {
    display: flex;
    align-items: center;

    strong {
      font-weight: bold;
      font-size: 18px;
      color: #FE553E;
    }

    span {
      font-weight: 400;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 14px;
      margin-left: 5px;
    }
  }
}

.card-block {
  .row2 {
    padding: 10px 0;
    font-size: 14px;
    color: white;
  }

  /deep/ .ant-input {
    height: 54px;
    color: white;
    background: rgba(255, 255, 255, 0.15);
    border: 0;
    border-radius: 12px 12px 12px 12px;
  }

  /deep/ .ant-calendar-picker-icon {
    color: white;
  }
}

.card-switch {
  padding: 10px 0;

  .row2 {
    padding: 10px 0;
    font-size: 14px;
    color: white;
  }
}

.add {
  display: block;
  width: 100%;
  padding: 0;
  margin-top: 30px;
}

.item-title {
  font-weight: 600;
  font-size: 14px;
  color: #FFFFFF;
}

.ant-modal-custom {
  /deep/ .ant-modal-content {
    background: linear-gradient(to bottom, #191f35, #252628);
  }

  /deep/ .ant-input {
    color: rgba(255, 255, 255, 0.4);
    background: transparent;
  }

  /deep/ .ant-input-number {
    color: rgba(255, 255, 255, 0.4);
    background: transparent;
  }

  .modal-title {
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 21px;
  }

  .item {
    margin-top: 20px;
    padding: 10px 15px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 12px 12px 12px 12px;
  }

  /deep/ .ant-form-item-label {
    line-height: unset;

    label {
      font-weight: 400;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 16px;
    }
  }

  /deep/ .ant-modal-footer {
    text-align: center;
    border-top: 0;
    padding-bottom: 30px;
  }

  /deep/ .ant-modal-close {
    color: white;
  }

  /deep/ .ant-tabs-tab {
    color: white;
  }

  /deep/ th {
    color: white;
    background: transparent;
  }

  /deep/ td {
    color: white;
    background: transparent;
  }

  /deep/ .ant-table-row-selected td {
    color: white;
    background: transparent;
  }

  /deep/ .ant-table-row-selected:hover td {
    color: white;
    background: #333;
  }

  /deep/ .ant-empty-description {
    color: white;
  }

  .footer {
    text-align: center;
  }
}
</style>